import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgPersonRegular = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M13.813 3.875a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0m-2.5 11.875v5.313c0 .519-.418.937-.938.937a.935.935 0 0 1-.937-.937V10.734l-1.684 2.977a.937.937 0 1 1-1.632-.922l2.287-4.043A3.44 3.44 0 0 1 11.402 7h1.07c1.243 0 2.384.668 2.993 1.746l2.29 4.043a.936.936 0 1 1-1.633.922l-1.684-2.977v10.329c0 .519-.418.937-.938.937a.935.935 0 0 1-.937-.937V15.75zm0-1.875h1.25V8.879q-.043-.005-.09-.004h-1.07q-.049-.001-.09.004z"
    }));
export default SvgPersonRegular;
